import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Linkedin } from 'lucide-react';

const footerLinks = {
  solution: [
    { label: 'Notre solution', href: '/solution' },
    { label: 'Comment ça marche', href: '/comment-ca-marche' },
    { label: 'Pour les aidants', href: '/pour-les-aidants' },
    { label: 'Pour les partenaires', href: '/pour-les-partenaires' },
    { label: 'Pour les mutuelles & CSE', href: '/pour-les-mutuelles' },
  ],
  ressources: [
    { label: 'FAQ', href: '/faq' },
    { label: 'Qualité & sécurité', href: '/qualite-securite' },
    { label: 'À propos', href: '/a-propos' },
    { label: 'Contact', href: '/contact' },
  ],
  legal: [
    { label: 'Mentions légales', href: '/mentions-legales' },
    { label: 'Politique de confidentialité', href: '/confidentialite' },
    { label: "Conditions d'utilisation", href: '/cgu' },
    { label: 'Politique cookies', href: '/cookies' },
  ]
};

const FlameLogo = () => (
  <svg width="30" height="30" viewBox="0 0 34 34" fill="none" aria-hidden="true">
    <rect width="34" height="34" rx="10" fill="rgba(255,255,255,0.12)"/>
    <path d="M17 6C17 6 10 12 10 18.5C10 22.09 13.13 25 17 25C20.87 25 24 22.09 24 18.5C24 12 17 6 17 6Z" fill="#F47B20"/>
    <path d="M17 14C17 14 14 17 14 19.5C14 21.16 15.34 22.5 17 22.5C18.66 22.5 20 21.16 20 19.5C20 17 17 14 17 14Z" fill="#FFB343"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <FlameLogo />
              <div>
                <span className="font-heading text-lg font-semibold text-white">M-CareLink</span>
                <p className="text-[9px] tracking-[0.18em] uppercase text-primary-foreground/50 font-body leading-none">Séjours de répit adaptés</p>
              </div>
            </Link>
            <p className="text-sm text-primary-foreground/65 leading-relaxed mb-6 font-body">
              Coordination de séjours de répit France-Maroc pour aidants et personnes aidées — Marrakech & Agadir.
            </p>
            <div className="space-y-2 text-sm text-primary-foreground/55 font-body">
              <div className="flex items-center gap-2">
                <Mail className="w-3.5 h-3.5 flex-shrink-0 text-accent" />
                <a href="mailto:contact@m-carelink.com" className="hover:text-white transition-colors">contact@m-carelink.com</a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-3.5 h-3.5 flex-shrink-0 text-accent" />
                <a href="tel:+33618883411" className="hover:text-white transition-colors">+33 6 18 88 34 11</a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-3.5 h-3.5 flex-shrink-0 text-accent" />
                <span>France · Maroc</span>
              </div>
            </div>
            <div className="flex gap-3 mt-5">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 hover:bg-accent transition-colors flex items-center justify-center">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 hover:bg-accent transition-colors flex items-center justify-center">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([key, links]) => (
            <div key={key}>
              <h4 className="font-body text-xs font-semibold uppercase tracking-[0.15em] mb-5 text-primary-foreground/60">
                {key === 'solution' ? 'Solution' : key === 'ressources' ? 'Ressources' : 'Légal'}
              </h4>
              <ul className="space-y-2.5">
                {links.map(link => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-primary-foreground/55 hover:text-white transition-colors font-body"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-primary-foreground/10 mt-14 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-primary-foreground/35 font-body">
            &copy; {new Date().getFullYear()} M-CareLink. Tous droits réservés.
          </p>
          <p className="text-xs text-primary-foreground/35 font-body">
            Coordination de séjours de répit — ne constitue pas un établissement de santé.
          </p>
        </div>
      </div>
    </footer>
  );
}
